export default {
  okText: 'ç¡®å®',
  cancelText: 'åæ¶'
};
